module.exports = __webpack_public_path__ + "static/media/bandera.6f70ecc1.svg";